import React, { FC } from 'react';
import { Box, Dialog, Divider, Stack, SvgIcon, Typography } from '@mui/material';
import styles from './NextStepsComponent.module.scss';
import boddVariables from '../../../variables.module.scss';
import ActionStepComponent from '../ActionStepComponent/ActionStepComponent';
import PhoneIcon from '../../../assets/phone.svg';
import CalendarIcon from '../../../assets/calendar.svg';
import BookingComponent from '../BookingComponent/BookingComponent';

interface NextStepsComponentProps {
}

const NextStepsComponent: FC<NextStepsComponentProps> = () => {
    const [modalOpen, setModalOpen] = React.useState(false);

    const handleModalOpen = () => {
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
    };

    return (
        <div className={styles.NextStepsComponent} data-testid="NextStepsComponent">
            <Box
                sx={{ my: 5 }}
            >
                <Typography
                    sx={{
                        textAlign: 'left',
                        fontFamily: 'Poppins',
                        fontWeight: '600',
                        fontSize: '24px',
                        lineHeight: '36px',
                    }}
                >
                    Next steps
                </Typography>
                <Divider sx={{ borderColor: boddVariables.black, backgroundColor: 'transparent', pt: 1.25, mb: 3 }} />
                <Stack>
                    <ActionStepComponent
                        title="Telehealth Consult"
                        icon={<SvgIcon sx={{ width: 24, height: 24 }}><PhoneIcon /></SvgIcon>}
                        action={handleModalOpen}
                    />
                    <ActionStepComponent
                        title="Annual Health Assessment"
                        icon={<SvgIcon sx={{ width: 24, height: 24 }}><CalendarIcon /></SvgIcon>}
                        action={handleModalOpen}
                    />
                </Stack>
            </Box>
            <Dialog
                fullScreen
                open={modalOpen}
                onClose={handleModalClose}
            >
                <BookingComponent handleClose={handleModalClose} />
            </Dialog>
        </div>
    );
};

export default NextStepsComponent;
